/**
 * Simple loading state component
 */
import { LoadingSpinner } from '@/components/common/LoadingSpinner';

interface LoadingStateProps {
  message?: string;
  size?: 'sm' | 'md' | 'lg';
}

export default function LoadingState({
  message,
  size = 'md',
}: LoadingStateProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-2">
      <LoadingSpinner size={size} />
      {message && (
        <p className="text-sm text-gray-600 dark:text-gray-400">{message}</p>
      )}
    </div>
  );
}
